module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "item-img-page",
    class: {
      'item-img-page-show': _vm.animationShow, 'item-img-page-hide': !_vm.animationShow
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imgTitleShow),
      expression: "imgTitleShow"
    }],
    staticClass: "item-img-title"
  }, [_vm._v(_vm._s(_vm.imgTitle))]), _vm._v(" "), _c('div', {
    staticClass: "item-img-container"
  }, [_c('img', {
    style: ({
      top: _vm.imgTop + 'px'
    }),
    attrs: {
      "src": _vm.imgSrcUrl,
      "onerror": _vm.imgErrorHandler
    },
    on: {
      "touchstart": _vm.touchstartImg,
      "touchmove": _vm.touchmoveImg,
      "touchend": _vm.touchendImg
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-64360727!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ItemImg.vue
// module id = 581
// module chunks = 1